enum ConsumptionModificationType {
  Increment,
  Decrement,
}

export default ConsumptionModificationType;
